import { type ReactNode } from "react";

export const TwoLineOptionLabel = ({
  title,
  subtitle
}: {
  title: ReactNode;
  subtitle?: ReactNode;
}) => (
  <div className="flex min-w-0 flex-col">
    <span className="break-words text-sm font-medium leading-4 text-content-1000">
      {title}
    </span>
    {subtitle ? (
      <span className="text-[10px] font-medium leading-3 text-content-300">
        {subtitle}
      </span>
    ) : null}
  </div>
);
